import { IGigPayoutsUpload } from "store/partner-services/partnerServicesSlice";

const PERSIST_KEY = "gig_payouts_processing";

export const persistProcessingGigPayouts = (data: IGigPayoutsUpload) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error persisting Gig Payouts data:", error);
  }
};

export const getPersistedProcessingGigPayouts = (): IGigPayoutsUpload => {
  try {
    const data = localStorage.getItem(PERSIST_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving Gig Payouts data:", error);
    return {};
  }
};

export const removePersistedProcessingGigPayouts = () => {
  try {
    localStorage.removeItem(PERSIST_KEY);
  } catch (error) {
    console.error("Error removing Gig Payouts data:", error);
  }
};
